// extracted by mini-css-extract-plugin
export var answers = "single-faq-module--answers--+bRRo";
export var button = "single-faq-module--button--o0QWV";
export var faq = "single-faq-module--faq--r9aHu";
export var questions = "single-faq-module--questions--Fr3ee";